import { useMemo } from 'react';

import type { RoomTask } from 'src/common/interfaces/tasks';

/**
 * Hook to determine if all questions in all tasks have been answered correctly
 * @param tasks Array of room tasks
 * @returns Boolean indicating if all questions have been answered correctly, or undefined if tasks is undefined
 */
export const useHasAnsweredAllQuestionsCorrectly = (tasks?: RoomTask[]): boolean | undefined =>
  useMemo(
    () =>
      tasks ? !tasks?.find((task) => !task.questions.every((question) => !!question.progress?.correct)) : undefined,
    [tasks],
  );
